import './custom_highchart.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.CustomHistogramChart extends Monitoring.Views.Charts.CustomHighchart
  url: '/monitoring/api/charts/histogram'
  className: 'processing item custom-chart w2'
  defaultSize: 'w2'

  events:
    'click #close_chart': 'destroy'

  initialize: (@options = {}) ->
    super(@options)
    if @facets['date']
      @initialTime = @facets['date'].min
      @finalTime = @facets['date'].max
    @calculateInterval()

  series: ->
    return [] if @data.series.length == 0
    @interval = @data.interval if @data.interval
    series = @data.series
    series = @orderSeries(series)
    for serie in series
      serie.type = @_settings.type
      serie.events = {
        click: @_previewSearch unless @_settings.avoid_preview
        legendItemClick: @legendItemClickEvent
      }
      if (serie.code + "").indexOf('missing') > -1
        serie.name = "No #{@_translateName @data.dimension}"
      serie.color = @customColors()[serie.code]
      serie.visible = @getVisibilityFor(serie.name)
    unless @totalInSeries or @_settings.type == 'area'
      total = @seriesTotal series
      series.push total
      @totalInSeries = true
    _.each(@options.eventList, (event) =>
      if(event.end_date && event.end_date != "")
        series.push({
          type: 'flags',
          name: event.name+' ends',
          color: '#222222',
          shape: 'squarepin',
          y: -55,
          data: [
            { x: new Date(event.end_date), title: event.name+' ends' }
          ],
          showInLegend: false
        })
      series.push({
        type: 'flags',
        name: event.name,
        color: '#333333',
        shape: 'squarepin',
        y: -55,
        data: [
          { x: new Date(event.start_date), title: event.name }
        ],
        showInLegend: false
      })
    )
    series

  seriesTotal: (series) ->
    total_data = []
    tooltip_data = {}
    point_numbers = series[0].data.length
    for i in [0...point_numbers]
      timestamp = series[0].data[i][0]
      sum = 0
      for serie in series
        sum += serie.data[i][1]
        tooltip_data[timestamp] = tooltip_data[timestamp] || []
        tooltip_data[timestamp].push [serie.name, serie.data[i][1]]
      total_data.push([timestamp, sum])
    {
      data: total_data,
      name: 'total',
      type: @_settings.type,
      visible: @_settings.total_visible || false,
      events:
        click: @previewTotal
        show: =>
          @_settings.total_visible = true
        hide: =>
      tooltip_data: tooltip_data
    }

  customOptions: ->
    toggleFlags = () =>
      _.each(@chart.series, (series) =>
        if (series.visible && series.type == 'flags')
          series.hide()
        else
          series.show();
      )

    showLegend = @showLegend()
    showMarker = @showMarkers()
    options = {
    chart:
      zoomType: 'x'
      events:
        selection: (event) => @onTimeseriesSelection(event)

    legend:
      enabled: showLegend
      verticalAlign: 'bottom'
      align: 'center'
      layout: 'horizontal'
      borderWidth: 0
      margin: 6
      maxHeight: 60
    plotOptions:
      spline:
        marker:
          enabled: showMarker
          states:
            hover:
              enabled: true
          symbol: 'circle'
        pointStart: @initialTime
      areaspline:
        stacking: null
        pointStart: @initialTime
        marker:
          enabled: false
          states:
            hover:
              enabled: true
      area:
        stacking: @_settings.stacking
        pointStart: @initialTime
        marker:
          enabled: false
          states:
            hover:
              enabled: true
    xAxis:
      type: 'datetime'
    yAxis:
      title: null
      min: 0
    tooltip:
      followPointer: true
      positioner: (labelWidth, labelHeight, point) ->
        chart = this.chart
        pointX = if (point.plotX + labelWidth > chart.plotWidth) then point.plotX + chart.plotLeft - labelWidth - 10 else point.plotX + chart.plotLeft + 10
        x = if pointX > 0 then pointX else 0
        y = if point.plotY + chart.plotTop - 20 > 35 then point.plotY + chart.plotTop - 20 else 35
        return { x: x , y: y }
      formatter: @formatter
      crosshairs: [true, true]
    exporting:
      buttons:
        contextButton:
          menuItems: [].concat @exportingOptions
    }

    menuItems = @translatedItems(Highcharts.getOptions().exporting.buttons.contextButton.menuItems)
    menuItems = menuItems.concat({separator:true})
    unless window.sharedSession
      menuItems = menuItems.concat({
        text: if @_settings.maximized then I18n.t('monitoring.dashboard.charts.export_options.normal') else I18n.t('monitoring.dashboard.charts.export_options.maximize')
        onclick: (() => @toggleMaximize())
      })
    menuItems = menuItems.concat(@exportingOptions)
    menuItems = menuItems.concat({
      text: I18n.t('monitoring.dashboard.charts.export_options.flags')
      onclick: (() -> toggleFlags())
    })
    options.exporting.buttons.contextButton.menuItems = menuItems
    options


  previewTotal: =>
    query = @searchQuery.deepCopy()
    query.addDateFrom(event.point.x)
    query.addDateTo(event.point.x + @interval * 60000)
    query.removeDateFromRealtime()
    @createPreviewDashboard(query)

  getNewQuery: (event) ->
    query = @searchQuery.deepCopy()
    query.addDateFrom(event.point.x)
    query.addDateTo(event.point.x + @interval * 60000)
    query.removeDateFromRealtime()
    @_setDimension(query, @_settings.dimension, @getValueForDimension(@_settings.dimension, event.point.series.options))
    return query

  calculateInterval: ->
    per_week = {text: I18n.t('monitoring.dashboard.charts.export_options.week'), onclick: @onClick(1440*7) }
    per_day = {text: I18n.t('monitoring.dashboard.charts.export_options.day'), onclick: @onClick(1440) }
    per_hour = {text: I18n.t('monitoring.dashboard.charts.export_options.hour'), onclick: @onClick(60) }
    per_half = {text: I18n.t('monitoring.dashboard.charts.export_options.half'), onclick: @onClick(30) }
    per_minute = {text: I18n.t('monitoring.dashboard.charts.export_options.minute'), onclick: @onClick(1) }

    minutes = (@finalTime - @initialTime) / 60000
    if minutes <= 120 # Less than 2 hours => 1 minute interval
      @exportingOptions = [per_hour, per_half, per_minute]
      @interval = 1
    else if minutes <= 720 # Less than 12 hours => 5 minutes interval
      @exportingOptions = [per_hour, per_half, per_minute]
      @interval = 5
    else if minutes <= 1440 # Less than 1 day => 10 minutes interval
      @exportingOptions = [per_hour, per_half, per_minute]
      @interval = 10
    else if minutes <= 1440*7 # Less than 1 week => 60 minutes interval
      @exportingOptions = [per_day, per_hour, per_half, per_minute]
      @interval = 60
    else if minutes <= 1440*30 # Less than 30 days => 6 hours interval
      @exportingOptions = [per_week, per_day, per_hour, per_half]
      @interval = 360
    else if minutes <= 1440*120 # Less than 120 days => 1 day interval
      @exportingOptions = [per_week, per_day, per_hour, per_half]
      @interval = 1440
    else # Anything else => 1 week interval
      @exportingOptions = [per_week, per_day, per_hour, per_half]
      @interval = 10080

  onClick: (interval) ->
    =>
      @interval = interval
      @data = null
      @afterAppend()

  fillEmptyGaps: ->
    fullInterval = @interval * 60000
    for serie in @data.series
      timestamp = serie[0][0]
      i = 1
      while serie[i]
        if serie[i][0] - timestamp > fullInterval
          serie.splice(i, 0, [timestamp+fullInterval, 0])
        timestamp = serie[i][0]
        i++


  getSearchQuery: ->
    query = @searchQuery.deepCopy()
    query.set('dimension', @_settings.dimension)
    query.set('interval', @interval)
    query

  formatter: ->
    date = (new Date(@point.x)).toString()
    date = date.substr(0, date.length-15)
    formatter_string = "#{date}<br>#{@point.series.name}: #{@y}"
    if @series.name == 'total'
      tooltip_data = @series.options.tooltip_data
      timestamp = @point.x
      for data in tooltip_data[timestamp]
        formatter_string += "<br>#{data[0]}: #{data[1]}"
    formatter_string

  showLegend: =>
    if @options.settings.showLegend  != undefined
      return @options.settings.showLegend
    true

  showMarkers: =>
    if @options.settings.showMarkers != undefined
      return @options.settings.showMarkers
    false
